import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchAsns, getOrders } from '../../api/ans';
import resetStore from '../resetStore';

const initialState = {
  allOrdersList: [],
};

export const getAllOrdersThunk = createAsyncThunk(
  'orders/getAllOrders',
  async (statusParams, { rejectWithValue }) => {
    try {
      const ordersList = await getOrders({ status_array: statusParams?.status_array });
      const asns = await fetchAsns({ status_array: statusParams?.status_array });

      const ordersArray = Array.isArray(ordersList.orders) ? ordersList.orders : [];
      const asnsArray = Array.isArray(asns.asns) ? asns.asns : [];

      const result = [...ordersArray, ...asnsArray];

      console.log(
        result,
        'result from getAllOrdersThunk with status:',
        statusParams?.status
      );

      return result;
    } catch (err) {
      console.error(err, 'Error in getAllOrdersThunk');
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Ошибка создания ASN'
      );
    }
  }
);

const allOrdersSlice = createSlice({
  name: 'allOrders',
  initialState,
  reducers: {
    setAllOrders(state, action) {
      state.allOrdersList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllOrdersThunk.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getAllOrdersThunk.fulfilled, (state, action) => {
        state.status = 'resolved';
        console.log(action.payload, 'action.payload from getAllOrdersThunk');
        state.allOrdersList = action.payload; // добавляем список заказов
      })
      .addCase(getAllOrdersThunk.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
      })
      .addCase(resetStore, () => initialState);
  },
});

export const { setAllOrders } = allOrdersSlice.actions;
export default allOrdersSlice.reducer;
